export const translations = {
  en: {
    // Navbar
    ido: 'IDO',
    mysteryBox: 'Mystery Box',
    mining: 'Mining',
    market: 'Market',
    airdrop: 'Airdrop',
    connectWallet: 'Connect Wallet',
    disconnect: 'Disconnect',
    connecting: 'Connecting...',

    // Home page
    welcome: 'ZERO',
    startMining: 'Start Mining',
    description: 'AI-powered NFT mining platform, automated mining and revenue distribution through smart contracts, building a decentralized digital asset ecosystem.',
    totalPowerLabel: 'Total Power',
    activeMinersLabel: 'Active Miners',
    minedTokensLabel: 'Mined Tokens',
    totalValueLabel: 'Total Value',
    
    // IDO page
    idoTitle: 'ZONE Mint',
    totalSupply: 'Total Supply',
    myParticipation: 'My Participation',
    depositAmount: 'Deposit Amount',
    expectedAmount: 'Expected Amount',
    participatedAmount: 'Participated Amount',
    expectedToReceive: 'Expected to Receive',
    totalIssuance: 'Total Issuance',
    privateSaleAmount: 'Private Sale Amount',
    privateSalePrice: 'Private Sale Price',
    targetAmount: 'Target Amount',
    exchangeRate: 'Exchange Rate',
    privatePrice: 'Private Sale Price',
    participationLimit: 'Participation Limit',
    purchaseLimit: 'Purchase Limit',
    enterParticipationAmount: 'Enter Participation Amount',
    connectWalletToParticipate: 'Connect Wallet to Participate',
    confirmParticipation: 'Mint',
    participationConfirm: 'Confirm Participation',
    pleaseConnectWallet: 'Please Connect Wallet First',
    transactionSuccess: 'Transaction Success',
    transactionFailed: 'Transaction Failed',
    participationSuccessful: 'Participation Successful!',
    transactionCancelled: 'Transaction Cancelled',
    insufficientBalance: 'Insufficient Balance',
    transactionFailedTryAgain: 'Transaction Failed, Please Try Again',
    invalidAmount: 'Please enter amount between {min}-{max} BNB',
    referralReward: 'Referral Reward: 10%',
    referralDescription: 'Share your referral link and get 10% reward when friends join IDO',
    copyLink: 'Copy Link',
    copied: 'Copied!', 

    // IDO Numbers
    oneHundredMillion: '100,000,000',   // 正确：加上逗号
    tenMillion: '10,000,000',
    fiveMillion: '5,000,000',
    twoMillion: '2,000,000',
    oneMillion: '1,000,000',
    fiveHundredThousand: '500,000',
    twoHundredFiftyThousand: '250,000',
    oneHundredThousand: '100,000',
    fiftyThousand: '50,000',
    twentyFiveThousand: '25,000',
    tenThousand: '10,000',
    fiveThousand: '5,000',
    twoThousand: '2,000',
    oneThousand: '1,000',
    fiveHundred: '500',
    twoHundredFifty: '250',
    oneHundred: '100',
    fifty: '50',
    twentyFive: '25',
    ten: '10',
    five: '5',
    two: '2',
    one: '1',
    
    // Mystery Box page
    mysteryBoxTitle: 'Mystery Box',
    mysteryBoxDesc: 'Open box to get rare NFTs',
    boxPrice: 'Box Price',
    openBox: 'Open Box',
    approving: 'Approving...',
    opening: 'Opening...',
    connectWalletFirst: 'Please connect wallet first',
    approvalFailed: 'Approval failed',
    openFailed: 'Failed to open box',
    nftProbability: 'NFT Probability',
    probability: 'Probability',
    quantity: 'Quantity',
    congratulations: 'Congratulations',
    youGot: 'You got',
    confirm: 'Confirm',
    nftRarityN: 'Normal',
    nftRarityR: 'Rare',
    nftRaritySR: 'Super Rare',
    nftRaritySSR: 'SSR',
    
    // Mining page
    miningTitle: 'NFT Mining',
    totalHashrate: 'Total Hashrate',
    miningRewards: 'Mining Rewards',
    nftMining: 'NFT Mining',
    realTimeMonitoring: 'Real-time Monitoring & Smart Revenue Analysis',
    minerCount: 'Miners',
    todayOutput: "Today's Output",
    totalOutput: 'Total Output',
    nftStatus: 'NFT Status',
    holdingCount: 'Holdings',
    totalPower: 'Total Power',
    miningLevel: 'Mining Level',
    directBonus: 'Direct Bonus',
    revenueStats: 'Revenue Statistics',
    currentRevenue: 'Current Revenue',
    dailyRevenue: 'Daily Revenue',
    maxRevenue: 'Max Revenue',
    estimatedAnnual: 'Est. Annual',
    directStatus: 'Direct Status',
    directCount: 'Direct Count',
    directIncome: 'Direct Income',
    currentLevel: 'Current Level',
    directIncrease: 'Direct Increase',
    myInviteCode: 'My Invite Code',
    copy: 'Copy',
    myNFT: 'My NFT',
    runningMachines: 'Running Machines',
    networkPower: 'Network Power',
    systemOnline: 'SYSTEM ONLINE',
    computingUnits: 'COMPUTING UNITS',
    systemMonitor: 'SYSTEM MONITOR',
    initializingSystem: 'INITIALIZING SYSTEM... CHECKING MEMORY... VERIFYING !!',

    // Market page
    nftMarketplace: 'NFT Market',
    nftMarketDescription: 'Trading and Collection of Unique Digital Assets',
    searchPlaceholder: 'Search NFT...',
    sortDefault: 'Sort By',
    sortPriceAsc: 'Price: Low to High',
    sortPriceDesc: 'Price: High to Low',
    sortPowerDesc: 'Power: High to Low',
    sortRewardDesc: 'Reward: High to Low',
    allListings: 'Market Listings',
    myListings: 'My NFTs',
    marketHistory: 'Trade History',
    totalVolume: 'Total Volume',
    floorPrice: 'Floor Price',
    totalHolders: 'NFT Total',
    totalListings: 'Total Listings',
    power: 'Power',
    dailyReward: 'Daily Reward',
    maxReward: 'Max Reward',
    yearReturn: 'Annual Return',
    currentPrice: 'Current Price',
    price: 'Price',
    buyNow: 'Buy Now',
    sellNow: 'Sell Now',
    delist: 'Cancel Listing',
    stakeNow: 'Stake Now',
    viewHistory: 'View History',
    listNFT: 'List NFT',
    listingPrice: 'Listing Price',
    pricePlaceholder: 'Enter price...',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    owner: 'Owner',
    seller: 'Seller',
    buyer: 'Buyer',
    time: 'Time',
    tokenId: 'Token ID',
    noHistory: 'No trade history',
    userHistory: 'My Trade History',
    connectWalletDesc: 'Connect your wallet to browse and trade NFTs',
    buySuccess: 'Purchase successful!',
    buyFailed: 'Purchase failed: ',
    listSuccess: 'Listing successful!',
    listFailed: 'Listing failed: ',
    delistSuccess: 'Delisting successful!',
    delistFailed: 'Delisting failed: ',
    stakeSuccess: 'Staking successful!',
    stakeFailed: 'Staking failed: ',
    stakeWarning: 'After staking, your NFT will be locked until you manually unstake. During this period, you will continuously receive ZONE token rewards.',
    confirmContribution: 'Confirm Contribution',

    // Token Distribution
    tokenDistributionTitle: 'Token Distribution',
    nftMiningAllocation: 'NFT Mining',
    privateSaleAllocation: 'Private Sale',
    liquidityAllocation: 'Joint Market Making',
    listingReserveAllocation: 'Listing Reserve',
    lpAllocation: 'LP',
    airdropAllocation: 'Airdrop',
    
    // Token Information
    tokenInfoTitle: 'Token Information',
    tokenName: 'Token Name',
    tokenSymbol: 'Token Symbol',
    totalSupply: 'Total Supply',
    network: 'Network',
    initialPrice: 'Initial Price',
    listingPrice: 'Listing Price',
    softCap: 'Soft Cap',
    hardCap: 'Hard Cap',
    
    // Features
    aiContractTitle: 'AI Smart Contract',
    aiContractDesc: 'Advanced smart contract system with AI-powered optimization',
    mysteryBoxTitle: 'Mystery Box System',
    mysteryBoxDesc: 'Exciting rewards and surprises in mystery boxes',
    nftMarketTitle: 'NFT Marketplace',
    nftMarketDesc: 'Trade and collect unique digital assets',
    
    // Mining Revenue
    miningRevenueTitle: 'Mining Revenue',
    basicRevenueTitle: 'Basic Revenue',
    stakingMechanismTitle: 'Staking Mechanism',
    revenueBoostTitle: 'Revenue Boost',
    
    // Basic Revenue
    nftLevelPower: 'NFT Level Power',
    dailyRevenueDistribution: 'Daily Revenue Distribution',
    revenueProportionalToPower: 'Revenue Proportional to Power',
    
    // Staking Mechanism
    stakeToMine: 'Stake to Mine',
    cannotUnstake: 'Cannot Unstake',
    noLockupPeriod: 'No Lockup Period',
    
    // Revenue Boost
    nftAttributeBonus: 'NFT Attribute Bonus',
    stakingDurationBonus: 'Staking Duration Bonus',
    eventBonus: 'Event Bonus',
    
    stakingMechanismTitle: 'Staking Mechanism',
    baseRevenueTitle: 'Base Revenue',
    baseRevenuePoint1: 'Higher NFT level, higher base revenue',
    baseRevenuePoint2: 'Daily revenue distribution',
    baseRevenuePoint3: 'Revenue proportional to staking duration',
    
    revenueBoostTitle: 'Revenue Boost',
    revenueBoostPoint1: 'Bonus for holding multiple NFTs',
    revenueBoostPoint2: 'Community activity affects revenue',
    revenueBoostPoint3: 'Extra rewards during special events',

    // Development Roadmap
    developmentRoadmap: 'Development Roadmap',
    phaseOne: 'Phase One',
    phaseTwo: 'Phase Two',
    phaseThree: 'Phase Three',
    phaseFour: 'Phase Four',
    
    phaseOneItem1: 'Complete Smart Contract Development',
    phaseOneItem2: 'Complete NFT System Design',
    phaseOneItem3: 'Complete Website Development',
    phaseOneItem4: 'Launch Private Sale',
    
    phaseTwoItem1: 'Launch IDO',
    phaseTwoItem2: 'Launch NFT Mining System',
    phaseTwoItem3: 'Open Marketplace',
    phaseTwoItem4: 'Start Joint Market Making',
    
    phaseThreeItem1: 'List on Major Exchanges',
    phaseThreeItem2: 'Launch NFT Upgrade System',
    phaseThreeItem3: 'Launch Team Mining System',
    phaseThreeItem4: 'Start Community Governance',
    
    phaseFourItem1: 'AI Smart Trading System',
    phaseFourItem2: 'AI Market Analysis & Prediction',
    phaseFourItem3: 'AI Personalized Investment Advice',
    phaseFourItem4: 'AI Risk Management System',

    // Roadmap
    roadmapTitle: 'Development Roadmap',
    phase1Title: 'Phase 1',
    phase1Point1: 'Complete smart contract development',
    phase1Point2: 'Complete NFT system design',
    phase1Point3: 'Complete website development',
    phase1Point4: 'Launch private sale',

    phase2Title: 'Phase 2',
    phase2Point1: 'Launch IDO',
    phase2Point2: 'Launch NFT mining system',
    phase2Point3: 'Open marketplace',
    phase2Point4: 'Start joint market making',

    phase3Title: 'Phase 3',
    phase3Point1: 'List on major exchanges',
    phase3Point2: 'Launch NFT upgrade system',
    phase3Point3: 'Launch team mining system',
    phase3Point4: 'Start community governance',

    phase4Title: 'Phase 4',
    phase4Point1: 'AI smart trading system',
    phase4Point2: 'AI market analysis & prediction',
    phase4Point3: 'AI personalized investment advice',
    phase4Point4: 'AI risk management system',

    // AI System
    aiSystemTitle: 'AI Smart System',
    flashArbitrageTitle: 'Flash Arbitrage',
    flashArbitragePoint1: 'Cross-chain arbitrage bot',
    flashArbitragePoint2: 'Real-time price monitoring',
    flashArbitragePoint3: 'Automatic trade execution',
    flashArbitragePoint4: 'Risk control system',
    flashArbitrageRequirement: 'Requires SR or higher level NFT',
    flashArbitrageItem1: 'Cross-exchange Arbitrage Bot',
    flashArbitrageItem2: 'Real-time Spread Monitoring',
    flashArbitrageItem3: 'Automated Trading',
    flashArbitrageItem4: 'Risk Control System',
    srRequirement: 'Requires SR or higher level NFT',
    
    smartTradingTitle: 'Smart Trading',
    smartTradingPoint1: 'AI trend analysis',
    smartTradingPoint2: 'Smart take-profit/stop-loss',
    smartTradingPoint3: 'Multi-strategy combination',
    smartTradingPoint4: 'Real-time market insights',
    smartTradingRequirement: 'Requires R or higher level NFT',
    smartTradingItem1: 'AI Trend Analysis',
    smartTradingItem2: 'Smart Stop Loss',
    smartTradingItem3: 'Multi-Strategy Portfolio',
    smartTradingItem4: 'Real-time Market Analysis',
    rRequirement: 'Requires R or higher level NFT',
    
    memeRadarTitle: 'MEME Radar',
    memeRadarPoint1: 'Social media monitoring',
    memeRadarPoint2: 'Hot token alerts',
    memeRadarPoint3: 'Sentiment indicator analysis',
    memeRadarPoint4: 'Early project discovery',
    memeRadarRequirement: 'Requires SSR level NFT',
    memeRadarItem1: 'Social Media Monitoring',
    memeRadarItem2: 'Hot Token Alert',
    memeRadarItem3: 'Sentiment Analysis',
    memeRadarItem4: 'Early Project Discovery',
    ssrRequirement: 'Requires SSR level NFT',
    
    scheduledTradingTitle: 'Scheduled Trading',
    scheduledTradingItem1: 'Custom Trading Plan',
    scheduledTradingItem2: 'Conditional Order Execution',
    scheduledTradingItem3: 'Multi-currency Monitoring',
    scheduledTradingItem4: 'Email/TG Notification',
    rRequirement: 'Requires R or higher level NFT',
    
    riskWarningTitle: 'Risk Warning',
    riskWarningItem1: 'Market Risk Monitoring',
    riskWarningItem2: 'Abnormal Movement Alert',
    riskWarningItem3: 'Capital Flow Analysis',
    riskWarningItem4: 'Smart Risk Control Strategy',
    srRequirement: 'Requires SR or higher level NFT',
    
    dataAnalysisTitle: 'Data Analysis',
    dataAnalysisItem1: 'Deep Market Analysis',
    dataAnalysisItem2: 'On-chain Data Tracking',
    dataAnalysisItem3: 'Trading Pattern Recognition',
    dataAnalysisItem4: 'Investment Report Generation',
    srRequirement: 'Requires SR or higher level NFT',
    
    aiSmartSystemTitle: 'AI Smart System',
    
    // Core Features Descriptions
    aiContractDescription: 'Advanced smart contract system with AI-powered optimization',
    mysteryBoxDescription: 'Exciting rewards and surprises in mystery boxes',
    nftMarketDescription: 'Trade and collect unique digital assets',
    
    // NFT Level System
    nftLevelSystemTitle: 'NFT Level System',
    normalNFT: 'Normal NFT',
    rareNFT: 'Rare NFT',
    superRareNFT: 'Super Rare NFT',
    legendaryNFT: 'Legendary NFT',
    
    drawProbability: 'Draw Probability',
    pityValue: 'Pity Value',
    noSpecialGuarantee: 'No Special Guarantee',
    srGuarantee: 'SR Guarantee',
    ssrGuarantee: 'SSR Guarantee',
    
    N: 'N',
    R: 'R',
    SR: 'SR',
    SSR: 'SSR',
    
    // Community
    joinCommunityTitle: 'Join Community',
    joinCommunity: 'Join Community',
    joinTelegramGroup: 'Join Telegram Group',
    followLatestUpdates: 'Follow Latest Updates',
    joinCommunityDiscussion: 'Join Community Discussion',
    telegramTitle: 'Telegram',
    telegramDescription: 'Join our telegram group',
    twitterDescription: 'Follow us on Twitter',
    discordDescription: 'Join our Discord server',

    communityListTitle: 'Community List',
    binanceCommunityTitle: 'Binance Community',
    binanceCommunityDescription: 'Global largest exchange',
    okxCommunityTitle: 'OKX Community',
    okxCommunityDescription: 'Leading digital asset platform',
    huobiCommunityTitle: 'Huobi Community',
    huobiCommunityDescription: 'Professional digital currency trading',
    gateCommunityTitle: 'Gate Community',
    gateCommunityDescription: 'Innovative digital asset platform',
    kucoinCommunityTitle: 'KuCoin Community',
    kucoinCommunityDescription: 'Global leading exchange',
    globalLeadingExchange: 'Global Leading Exchange',

    communitiesTitle: 'Communities',
    binanceCommunityTitle: 'Binance Community',
    binanceCommunityDescription: 'Global Leading Exchange',
    okxCommunityTitle: 'OKX Community',
    okxCommunityDescription: 'Leading Digital Asset Platform',
    huobiCommunityTitle: 'Huobi Community',
    huobiCommunityDescription: 'Professional Digital Currency Trading',
    gateCommunityTitle: 'Gate Community',
    gateCommunityDescription: 'Innovative Digital Asset Platform',
    kucoinCommunityTitle: 'KuCoin Community',
    kucoinCommunityDescription: 'Global leading exchange',

    // Discord
    discordTitle: 'Discord',
    discordDescription: 'Join Community Discussion',

    // Twitter
    twitterTitle: 'Twitter',
    twitterDescription: 'Follow Latest Updates',

    // Telegram
    telegramTitle: 'Telegram',
    telegramDescription: 'Join Official Channel',

    // Copyright
    copyright: '2025 ZERO. All rights reserved.',
    globalLeadingExchange: 'Global Leading Exchange',
    
    // Project Highlights
    projectHighlights: 'Project Highlights',
    aiTechnologyAdvancement: 'AI Technology Advancement',
    securityGuarantee: 'Security Guarantee',
    communityGovernance: 'Community Governance',
    ecosystemExpansion: 'Ecosystem Expansion',
    
    aiTechnologyDesc: 'Advanced AI algorithms for smart trading and risk management',
    securityDesc: 'Multi-layer security system with real-time monitoring',
    governanceDesc: 'Community-driven decision making and transparent governance',
    expansionDesc: 'Continuous ecosystem growth and partnership development',
    
    // News Announcements
    newsAnnouncements: 'News & Announcements',
    newsTitle1: 'AI Mining System Launch',
    newsContent1: 'Our advanced AI mining system is now live, bringing intelligent automation to crypto mining',
    newsTitle2: 'Strategic Partnership Announcement',
    newsContent2: 'New partnership with leading blockchain security firm to enhance platform safety',
    newsTitle3: 'Community Governance Update',
    newsContent3: 'Introducing new community voting system for project decisions',
    
    // Footer Community List
    communityList: 'Community Partners',
    binanceCommunity: 'Binance',
    okxCommunity: 'OKX',
    huobiCommunity: 'Huobi',
    kucoinCommunity: 'KuCoin',
    globalLeadingExchange: 'Global Leading Exchange',
  },
  ko: {
    // Navbar
    ido: 'IDO',
    mysteryBox: '미스터리 박스',
    mining: '채굴',
    market: '마켓',
    airdrop: '에어드롭',
    connectWallet: '지갑 연결',
    disconnect: '연결 해제',
    connecting: '연결 중...',

    // Home page
    welcome: 'ZERO',
    startMining: '채굴 시작',
    description: 'AI 기반 NFT 채굴 플랫폼으로, 스마트 계약을 통한 자동화된 채굴과 보상 분배를 실현하여 탈중앙화된 디지털 자산 생태계를 구축합니다.',
    totalPowerLabel: '총 파워',
    activeMinersLabel: '활성 채굴자',
    minedTokensLabel: '채굴된 토큰',
    totalValueLabel: '총 가치',
    
    // IDO page
    idoTitle: 'ZONE Mint',
    totalSupply: '총 공급량',
    myParticipation: '내 참여',
    depositAmount: '입여 수량',
    expectedAmount: '예상 수령량',
    participatedAmount: '참여 수량',
    expectedToReceive: '예상 수령량',
    totalIssuance: '총 발행량',
    privateSaleAmount: '프라이빗 세일 수량',
    privateSalePrice: '프라이빗 세일 가격',
    targetAmount: '목금액',
    raisedAmount: '모금액',
    exchangeRate: '교환 비율',
    privatePrice: '프라이빗 세일 가격',
    participationLimit: '참여 한도',
    purchaseLimit: '참여 한도',
    enterParticipationAmount: '참여 수량 입력',
    connectWalletToParticipate: '지갑 연결하여 참여하기',
    confirmParticipation: 'Mint',
    participationConfirm: '참여 확인',
    pleaseConnectWallet: '지갑을 먼저 연결해주세요',
    transactionSuccess: '거래 성공',
    transactionFailed: '거래 실패',
    participationSuccessful: '참여 성공!',
    transactionCancelled: '거래가 취소되었습니다',
    insufficientBalance: '잔액 부족',
    transactionFailedTryAgain: '거래 실패, 다시 시도해주세요',
    invalidAmount: '{min}-{max} BNB 사이의 수량을 입력해주세요',
    referralReward: '추천 보상: 10%',
    referralDescription: '추천 링크를 공유하고 친구가 참여하면 10% 보상을 받으세요',
    copyLink: '링크 복사',  
    copied: '복사 완료!',
    
    // IDO Numbers
    oneHundredMillion: '1억',
    tenMillion: '1천만',
    fiveMillion: '5백만',
    twoMillion: '2백만',
    oneMillion: '1백만',
    fiveHundredThousand: '5십만',
    twoHundredFiftyThousand: '2십오만',
    oneHundredThousand: '1십만',
    fiftyThousand: '5만',
    twentyFiveThousand: '2만오천',
    tenThousand: '1만',
    fiveThousand: '5천',
    twoThousand: '2천',
    oneThousand: '1천',
    fiveHundred: '5백',
    twoHundredFifty: '2백오십',
    oneHundred: '1백',
    fifty: '5십',
    twentyFive: '2십오',
    ten: '1십',
    five: '오',
    two: '이',
    one: '일',
    
    // Mystery Box page
    mysteryBoxTitle: '미스터리 박스',
    mysteryBoxDesc: '박스를 열어 희귀 NFT를 획득하세요',
    boxPrice: '박스 가격',
    openBox: '박스 열기',
    approving: '승인 중...',
    opening: '여는 중...',
    connectWalletFirst: '지갑을 먼저 연결해주세요',
    approvalFailed: '승인 실패',
    openFailed: '박스 열기 실패',
    nftProbability: 'NFT 확률',
    probability: '확률',
    quantity: '수량',
    congratulations: '축하합니다',
    youGot: '획득한 아이템',
    confirm: '확인',
    nftRarityN: '일반',
    nftRarityR: '희귀',
    nftRaritySR: '초희귀',
    nftRaritySSR: 'SSR',
    
    // Mining page
    miningTitle: 'NFT 채굴',
    totalHashrate: '총 해시레이트',
    miningRewards: '채굴 보상',
    nftMining: 'NFT 채굴',
    realTimeMonitoring: '실시간 모니터링 및 스마트 수익 분석',
    minerCount: '채굴자 수',
    todayOutput: '오늘의 채굴량',
    totalOutput: '총 채굴량',
    nftStatus: 'NFT 상태',
    holdingCount: '보유 수량',
    totalPower: '총 해시파워',
    miningLevel: '채굴 레벨',
    directBonus: '직접 보너스',
    revenueStats: '수익 통계',
    currentRevenue: '현재 수익',
    dailyRevenue: '일일 수익',
    maxRevenue: '총 수익 상한',
    estimatedAnnual: '예상 연간',
    directStatus: '직접 상태',
    directCount: '직접 추천 수',
    directIncome: '직접 수입',
    currentLevel: '현재 레벨',
    directIncrease: '직접 증가',
    myInviteCode: '내 초대 코드',
    copy: '복사',
    myNFT: '내 NFT',
    runningMachines: '가동 중인 기계',
    networkPower: '네트워크 파워',
    systemOnline: '시스템 온라인',
    computingUnits: '컴퓨팅 유닛',
    systemMonitor: '시스템 모니터',
    initializingSystem: '시스템 초기화 중... 메모리 확인 중... 검증 중!!',

    // Market page
    nftMarketplace: 'NFT 마켓',
    nftMarketDescription: '고유한 디지털 자산의 거래 및 수집',
    searchPlaceholder: 'NFT 검색...',
    sortDefault: '정렬 방식',
    sortPriceAsc: '가격: 낮은순',
    sortPriceDesc: '가격: 높은순',
    sortPowerDesc: '파워: 높은순',
    sortRewardDesc: '보상: 높은순',
    allListings: '마켓 리스트',
    myListings: '내 NFT',
    marketHistory: '거래 내역',
    totalVolume: '총 거래량',
    floorPrice: '최저가',
    totalHolders: 'NFT 총량',
    totalListings: '총 리스팅',
    power: '파워',
    dailyReward: '일일 보상',
    maxReward: '최대 보상',
    yearReturn: '연간 수익',
    currentPrice: '현재 가격',
    price: '가격',
    buyNow: '구매하기',
    sellNow: '판매하기',
    delist: '리스팅 취소',
    stakeNow: '스테이킹하기',
    viewHistory: '거래내역 보기',
    listNFT: 'NFT 리스팅',
    listingPrice: '판매 가격',
    pricePlaceholder: '가격 입력...',
    confirm: '확인',
    cancel: '취소',
    close: '닫기',
    owner: '소유자',
    seller: '판매자',
    buyer: '구매자',
    time: '시간',
    tokenId: '토큰 ID',
    noHistory: '거래 내역이 없습니다',
    userHistory: '내 거래 내역',
    connectWalletDesc: 'NFT를 거래하려면 지갑을 연결하세요',
    buySuccess: '구매가 완료되었습니다!',
    buyFailed: '구매 실패: ',
    listSuccess: '리스팅이 완료되었습니다!',
    listFailed: '리스팅 실패: ',
    delistSuccess: '리스팅 취소가 완료되었습니다!',
    delistFailed: '리스팅 취소 실패: ',
    stakeSuccess: '스테이킹이 완료되었습니다!',
    stakeFailed: '스테이킹 실패: ',
    stakeWarning: '스테이킹 후에는 수동으로 해제할 때까지 NFT가 잠깁니다. 이 기간 동안 ZONE 토큰 보상을 지속적으로 받게 됩니다.',
    confirmContribution: '참여 확인',

    // Token Distribution
    tokenDistributionTitle: '토큰 분배',
    nftMiningAllocation: 'NFT 마이닝',
    privateSaleAllocation: '프라이빗 세일',
    liquidityAllocation: '유동성 공급',
    listingReserveAllocation: '상장 예치금',
    lpAllocation: 'LP',
    airdropAllocation: '에어드롭',
    
    // Token Information
    tokenInfoTitle: '토큰 정보',
    tokenName: '토큰명',
    tokenSymbol: '토큰 심볼',
    totalSupply: '총 발행량',
    network: '네트워크',
    initialPrice: '초기 가격',
    listingPrice: '상장 가격',
    softCap: '소프트 캡',
    hardCap: '하드 캡',
    
    // Features
    aiContractTitle: 'AI 스마트 계약',
    aiContractDesc: '스마트 계약 자동 실행, 투명한 거래, 실시간 정산',
    mysteryBoxTitle: '미스터리 박스 시스템',
    mysteryBoxDesc: '4가지 희귀도의 NFT, 독특한 디자인, 특별한 속성 부여',
    nftMarketTitle: 'NFT 거래소',
    nftMarketDesc: '자유로운 NFT 거래, 실시간 시장 데이터, 안전한 거래 보장',

    // Mining Revenue
    miningRevenueTitle: '채굴 수익',
    basicRevenueTitle: '기본 수익',
    stakingMechanismTitle: '스테이킹 메커니즘',
    revenueBoostTitle: '수익 부스트',
    
    // Basic Revenue
    nftLevelPower: 'NFT 등급 파워',
    dailyRevenueDistribution: '일일 수익 분배',
    revenueProportionalToPower: '파워 비례 수익',
    
    // Staking Mechanism
    stakeToMine: '채굴을 위한 스테이킹',
    cannotUnstake: '언스테이킹 불가',
    noLockupPeriod: '락업 기간 없음',
    
    // Revenue Boost
    nftAttributeBonus: 'NFT 속성 보너스',
    stakingDurationBonus: '스테이킹 기간 보너스',
    eventBonus: '이벤트 보너스',
    
    stakingMechanismTitle: '스테이킹 메커니즘',
    baseRevenueTitle: '기본 수익',
    baseRevenuePoint1: 'NFT 등급이 높을수록 기본 수익이 높습니다',
    baseRevenuePoint2: '일일 정시에 수익 지급',
    baseRevenuePoint3: '수익은 스테이킹 기간에 비례합니다',
    
    revenueBoostTitle: '수익 부스트',
    revenueBoostPoint1: '다수의 NFT 보유 시 보너스',
    revenueBoostPoint2: '커뮤니티 활동도가 수익에 영향',
    revenueBoostPoint3: '특별 이벤트 기간 추가 보상',

    // Development Roadmap
    developmentRoadmap: '개발 로드맵',
    phaseOne: '제1단계',
    phaseTwo: '제2단계',
    phaseThree: '제3단계',
    phaseFour: '제4단계',
    
    phaseOneItem1: '스마트 컨트랙트 개발 완료',
    phaseOneItem2: 'NFT 시스템 설계 완료',
    phaseOneItem3: '웹사이트 개발 완료',
    phaseOneItem4: '프라이빗 세일 시작',
    
    phaseTwoItem1: 'IDO 시작',
    phaseTwoItem2: 'NFT 채굴 시스템 출시',
    phaseTwoItem3: '거래소 오픈',
    phaseTwoItem4: '공동 마켓 메이킹 시작',
    
    phaseThreeItem1: '주요 거래소 상장',
    phaseThreeItem2: 'NFT 업그레이드 시스템 개시',
    phaseThreeItem3: '팀 채굴 시스템 도입',
    phaseThreeItem4: '커뮤니티 거버넌스 시작',
    
    phaseFourItem1: 'AI 스마트 거래 시스템',
    phaseFourItem2: 'AI 시장 분석 및 예측',
    phaseFourItem3: 'AI 개인 맞춤형 투자 조언',
    phaseFourItem4: 'AI 리스크 관리 시스템',

    // Roadmap
    roadmapTitle: '개발 로드맵',
    phase1Title: 'Phase 1',
    phase1Point1: 'Complete smart contract development',
    phase1Point2: 'Complete NFT system design',
    phase1Point3: 'Complete website development',
    phase1Point4: 'Launch private sale',

    phase2Title: 'Phase 2',
    phase2Point1: 'Launch IDO',
    phase2Point2: 'Launch NFT mining system',
    phase2Point3: 'Open marketplace',
    phase2Point4: 'Start joint market making',

    phase3Title: 'Phase 3',
    phase3Point1: 'List on major exchanges',
    phase3Point2: 'Launch NFT upgrade system',
    phase3Point3: 'Launch team mining system',
    phase3Point4: 'Start community governance',

    phase4Title: 'Phase 4',
    phase4Point1: 'AI smart trading system',
    phase4Point2: 'AI market analysis & prediction',
    phase4Point3: 'AI personalized investment advice',
    phase4Point4: 'AI risk management system',

    // AI System
    aiSystemTitle: 'AI 스마트 시스템',
    flashArbitrageTitle: '플래시 아비트라지',
    flashArbitragePoint1: '크로스 체인 아비트라지 봇',
    flashArbitragePoint2: '실시간 가격 모니터링',
    flashArbitragePoint3: '자동 트레이딩 실행',
    flashArbitragePoint4: '리스크 컨트롤 시스템',
    flashArbitrageRequirement: 'SR 이상의 NFT 필요',
    flashArbitrageItem1: '크로스 거래소 차익거래 봇',
    flashArbitrageItem2: '실시간 스프레드 모니터링',
    flashArbitrageItem3: '자동화된 거래',
    flashArbitrageItem4: '리스크 관리 시스템',
    srRequirement: 'SR 이상 등급 NFT 필요',
    
    smartTradingTitle: '스마트 트레이딩',
    smartTradingPoint1: 'AI 트렌드 분석',
    smartTradingPoint2: '스마트 테이크 프로핏/스톱 로스',
    smartTradingPoint3: '멀티 전략 조합',
    smartTradingPoint4: '실시간 시장洞察',
    smartTradingRequirement: 'R 이상의 NFT 필요',
    smartTradingItem1: 'AI 트렌드 분석',
    smartTradingItem2: '스마트 손절매',
    smartTradingItem3: '멀티 전략 포트폴리오',
    smartTradingItem4: '실시간 시장 분석',
    rRequirement: 'R 이상 등급 NFT 필요',
    
    memeRadarTitle: 'MEME 레이더',
    memeRadarPoint1: '소셜 미디어 모니터링',
    memeRadarPoint2: '핫 토큰 알림',
    memeRadarPoint3: '센티먼트 인디케이터 분석',
    memeRadarPoint4: '초기 프로젝트 발견',
    memeRadarRequirement: 'SSR 이상의 NFT 필요',
    memeRadarItem1: '소셜 미디어 모니터링',
    memeRadarItem2: '핫 토큰 알림',
    memeRadarItem3: '감성 분석',
    memeRadarItem4: '초기 프로젝트 발견',
    ssrRequirement: 'SSR 이상의 NFT 필요',
    
    scheduledTradingTitle: '정시 거래',
    scheduledTradingItem1: '맞춤형 거래 계획',
    scheduledTradingItem2: '조건부 주문 실행',
    scheduledTradingItem3: '다중 화폐 모니터링',
    scheduledTradingItem4: '이메일/텔레그램 알림',
    rRequirement: 'R 이상 등급 NFT 필요',
    
    riskWarningTitle: '리스크 경고',
    riskWarningItem1: '시장 리스크 모니터링',
    riskWarningItem2: '이상 움직임 경고',
    riskWarningItem3: '자금 흐름 분석',
    riskWarningItem4: '스마트 리스크 관리 전략',
    srRequirement: 'SR 이상 등급 NFT 필요',
    
    dataAnalysisTitle: '데이터 분석',
    dataAnalysisItem1: '심층 시장 분석',
    dataAnalysisItem2: '온체인 데이터 추적',
    dataAnalysisItem3: '거래 패턴 인식',
    dataAnalysisItem4: '투자 보고서 생성',
    srRequirement: 'SR 이상 등급 NFT 필요',
    
    aiSmartSystemTitle: 'AI 스마트 시스템',
    
    // Core Features Descriptions
    aiContractDescription: 'AI 기반 최적화된 스마트 컨트랙트 시스템',
    mysteryBoxDescription: '미스터리 박스에서 제공되는 흥미진진한 보상',
    nftMarketDescription: '독특한 디지털 자산의 거래와 수집',
    
    // NFT Level System
    nftLevelSystemTitle: 'NFT 등급 시스템',
    normalNFT: '일반 NFT',
    rareNFT: '희귀 NFT',
    superRareNFT: '초희귀 NFT',
    legendaryNFT: '전설 NFT',
    
    drawProbability: '획득 확률',
    pityValue: '보상 수치',
    noSpecialGuarantee: '특별 보장 없음',
    srGuarantee: 'SR 등급 보장',
    ssrGuarantee: 'SSR 등급 보장',
    
    N: 'N',
    R: 'R',
    SR: 'SR',
    SSR: 'SSR',
    
    // Community
    joinCommunityTitle: '커뮤니티 참여',
    joinCommunity: '커뮤니티 참여',
    joinTelegramGroup: '텔레그램 그룹 참여',
    followLatestUpdates: '최신 업데이트 팔로우',
    joinCommunityDiscussion: '커뮤니티 토론 참여',
    telegramTitle: '텔레그램',
    telegramDescription: '텔레그램 그룹에 참여하세요',
    twitterDescription: '트위터에서 최신 소식을 확인하세요',
    discordDescription: '디스코드 서버에 참여하세요',

    communityListTitle: '커뮤니티 목록',
    binanceCommunityTitle: '바이낸스 커뮤니티',
    binanceCommunityDescription: '글로벌 최대 거래소',
    okxCommunityTitle: 'OKX 커뮤니티',
    okxCommunityDescription: '리딩 디지털 자산 플랫폼',
    huobiCommunityTitle: '후오비 커뮤니티',
    huobiCommunityDescription: '프로페셔널 디지털 통화 트레이딩',
    gateCommunityTitle: '게이트 커뮤니티',
    gateCommunityDescription: '혁신적인 디지털 자산 플랫폼',
    kucoinCommunityTitle: '쿠코인 커뮤니티',
    kucoinCommunityDescription: '글로벌 선도 거래소',
    globalLeadingExchange: '글로벌 선도 거래소',

    communitiesTitle: '커뮤니티',
    binanceCommunityTitle: '바이낸스 커뮤니티',
    binanceCommunityDescription: '글로벌 선도 거래소',
    okxCommunityTitle: 'OKX 커뮤니티',
    okxCommunityDescription: '리딩 디지털 자산 플랫폼',
    huobiCommunityTitle: '후오비 커뮤니티',
    huobiCommunityDescription: '프로페셔널 디지털 통화 트레이딩',
    gateCommunityTitle: '게이트 커뮤니티',
    gateCommunityDescription: '혁신적인 디지털 자산 플랫폼',
    kucoinCommunityTitle: '쿠코인 커뮤니티',
    kucoinCommunityDescription: '글로벌 선도 거래소',

    // Discord
    discordTitle: 'Discord',
    discordDescription: '커뮤니티 토론 참여',

    // Twitter
    twitterTitle: 'Twitter',
    twitterDescription: '최신 업데이트 팔로우',

    // Telegram
    telegramTitle: 'Telegram',
    telegramDescription: '공식 채널 참여',

    // Copyright
    copyright: '2025 ZERO. 모든 권리 보유.',
    globalLeadingExchange: '글로벌 선도 거래소',
    
    // Project Highlights
    projectHighlights: '프로젝트 하이라이트',
    aiTechnologyAdvancement: 'AI 기술 발전',
    securityGuarantee: '보안 보증',
    communityGovernance: '커뮤니티 거버넌스',
    ecosystemExpansion: '생태계 확장',
    
    aiTechnologyDesc: '스마트 거래 및 위험 관리를 위한 고급 AI 알고리즘',
    securityDesc: '실시간 모니터링이 포함된 다층 보안 시스템',
    governanceDesc: '커뮤니티 주도의 의사 결정 및 투명한 거버넌스',
    expansionDesc: '지속적인 생태계 성장 및 파트너십 개발',
    
    // News Announcements
    newsAnnouncements: '뉴스 & 공지사항',
    newsTitle1: 'AI 마이닝 시스템 출시',
    newsContent1: '고급 AI 마이닝 시스템이 가동되어 암호화폐 채굴에 지능형 자동화를 도입했습니다',
    newsTitle2: '전략적 파트너십 발표',
    newsContent2: '플랫폼 보안 강화를 위해 선도적인 블록체인 보안 기업과 새로운 파트너십 체결',
    newsTitle3: '커뮤니티 거버넌스 업데이트',
    newsContent3: '프로젝트 의사 결정을 위한 새로운 커뮤니티 투표 시스템 도입',
    
    // Footer Community List
    communityList: '커뮤니티 파트너',
    binanceCommunity: '바이낸스',
    okxCommunity: 'OKX',
    huobiCommunity: '후오비',
    kucoinCommunity: '쿠코인',
    globalLeadingExchange: '글로벌 선도 거래소',
  },
  zh: {
    // Navbar
    ido: 'IDO',
    mysteryBox: '神秘盲盒',
    mining: '挖矿',
    market: '市场',
    airdrop: '空投',
    connectWallet: '连接钱包',
    disconnect: '断开连接',
    connecting: '连接中...',

    // Home page
    welcome: 'ZERO',
    startMining: '开始挖矿',
    description: '基于人工智能的NFT挖矿平台，通过智能合约实现自动化挖矿和收益分配，打造去中心化的数字资产生态系统。',
    totalPowerLabel: '总算力',
    activeMinersLabel: '活跃矿工',
    minedTokensLabel: '已挖出代币',
    totalValueLabel: '总市值',
    
    // IDO page
    idoTitle: 'ZONE Mint',
    totalSupply: '总量',
    myParticipation: '我的参与',
    depositAmount: '存入数量',
    expectedAmount: '预计获得',
    participatedAmount: '已参与数量',
    expectedToReceive: '预计获得',
    totalIssuance: '发行总量',
    privateSaleAmount: 'Mint',
    privateSalePrice: 'Mint价格',
    targetAmount: '目标金额',
    raisedAmount: '已筹集',
    exchangeRate: '兑换比例',
    privatePrice: 'Mint价格',
    participationLimit: '参与限额',
    purchaseLimit: '购买限额',
    enterParticipationAmount: '输入参与数量',
    connectWalletToParticipate: '连接钱包参与',
    confirmParticipation: 'Mint',
    participationConfirm: '确认参与',
    pleaseConnectWallet: '请先连接钱包',
    transactionSuccess: '交易成功',
    transactionFailed: '交易失败',
    participationSuccessful: '参与成功！',
    transactionCancelled: '交易已取消',
    insufficientBalance: '余额不足',
    transactionFailedTryAgain: '交易失败，请重试',
    invalidAmount: '请输入{min}-{max} BNB之间的数量',
    referralReward: '推荐奖励：10%',
    referralDescription: '分享你的推荐链接，当朋友参与 IDO 时你可以获得 10% 奖励',
    copyLink: '复制链接',
    copied: '已复制！',
    
    // IDO Numbers
    oneHundredMillion: '1亿',
    tenMillion: '1000万',
    fiveMillion: '500万',
    twoMillion: '200万',
    oneMillion: '100万',
    fiveHundredThousand: '50万',
    twoHundredFiftyThousand: '25万',
    oneHundredThousand: '10万',
    fiftyThousand: '5万',
    twentyFiveThousand: '2.5万',
    tenThousand: '1万',
    fiveThousand: '5000',
    twoThousand: '2000',
    oneThousand: '1000',
    fiveHundred: '500',
    twoHundredFifty: '250',
    oneHundred: '100',
    fifty: '50',
    twentyFive: '25',
    ten: '10',
    five: '5',
    two: '2',
    one: '1',
    
    // Mystery Box page
    mysteryBoxTitle: '神秘盲盒',
    mysteryBoxDesc: '开启盲盒，获得稀有 NFT',
    boxPrice: '盲盒价格',
    openBox: '开启盲盒',
    approving: '授权中',
    opening: '开启中',
    connectWalletFirst: '请先连接钱包',
    approvalFailed: '授权失败',
    openFailed: '开箱失败',
    nftProbability: 'NFT 概率',
    probability: '概率',
    quantity: '数量',
    congratulations: '恭喜！您已成功获得空投资格',
    allocation: '您的空投分配是：',
    youGot: '您获得了',
    confirm: '确定',
    nftRarityN: '普通',
    nftRarityR: '稀有',
    nftRaritySR: '超稀有',
    nftRaritySSR: 'SSR',
    
    // Mining page
    miningTitle: 'NFT 挖矿',
    totalHashrate: '总算力',
    miningRewards: '挖矿奖励',
    nftMining: 'NFT 挖矿',
    realTimeMonitoring: '实时算力监控·智能收益分析',
    minerCount: '挖矿人数',
    todayOutput: '今日产出',
    totalOutput: '累计产出',
    nftStatus: 'NFT 状态',
    holdingCount: '持有数量',
    totalPower: '总算力',
    miningLevel: '挖矿等级',
    directBonus: '直推加成',
    revenueStats: '收益统计',
    currentRevenue: '当前收益',
    dailyRevenue: '日收益',
    maxRevenue: '总收益上限',
    estimatedAnnual: '预计年化',
    directStatus: '直推状态',
    directCount: '直推人数',
    directIncome: '直推收益',
    currentLevel: '当前等级',
    directIncrease: '直推加成',
    myInviteCode: '我的邀请码',
    copy: '复制',
    myNFT: '我的 NFT',
    runningMachines: '运行矿机',
    networkPower: '全网算力',
    systemOnline: '系统在线',
    computingUnits: '计算单元',
    systemMonitor: '系统监控',
    initializingSystem: '初始化系统... 检查内存... 验证中!!',

    // Market page
    nftMarketplace: 'NFT 交易市场',
    nftMarketDescription: '独特数字资产的交易与收藏',
    searchPlaceholder: '搜索 NFT...',
    sortDefault: '排序方式',
    sortPriceAsc: '价格: 从低到高',
    sortPriceDesc: '价格: 从高到低',
    sortPowerDesc: '算力: 从高到低',
    sortRewardDesc: '收益: 从高到低',
    allListings: '市场列表',
    myListings: '我的 NFT',
    marketHistory: '交易历史',
    totalVolume: '总交易额',
    floorPrice: '地板价',
    totalHolders: 'NFT总量',
    totalListings: '总挂单',
    power: '算力',
    dailyReward: '日收益',
    maxReward: '最大收益',
    yearReturn: '年化收益',
    currentPrice: '当前价格',
    price: '价格',
    buyNow: '立即购买',
    sellNow: '出售',
    delist: '取消出售',
    stakeNow: '去质押',
    viewHistory: '查看历史',
    listNFT: '上架 NFT',
    listingPrice: '出售价格',
    pricePlaceholder: '输入价格...',
    confirm: '确定',
    cancel: '取消',
    close: '关闭',
    owner: '拥有者',
    seller: '卖家',
    buyer: '买家',
    time: '时间',
    tokenId: 'NFT ID',
    noHistory: '暂无交易记录',
    userHistory: '我的交易历史',
    connectWalletDesc: '连接钱包以浏览和交易 NFT',
    buySuccess: '购买成功！',
    buyFailed: '购买失败：',
    listSuccess: '上架成功！',
    listFailed: '上架失败：',
    delistSuccess: '下架成功！',
    delistFailed: '下架失败：',
    stakeSuccess: '质押成功！',
    stakeFailed: '质押失败：',
    stakeWarning: '质押后NFT将被锁定，直到您手动解除质押。在此期间，您将持续获得ZONE代币奖励。',
    confirmContribution: '确认参与',

    // Token Distribution
    tokenDistributionTitle: '代币分配',
    nftMiningAllocation: 'NFT 挖矿',
    privateSaleAllocation: 'Mint',
    liquidityAllocation: 'LP挖矿',
    listingReserveAllocation: '上市储备',
    lpAllocation: 'LP',
    airdropAllocation: '空投',
    
    // Token Information
    tokenInfoTitle: '代币信息',
    tokenName: '代币名称',
    tokenSymbol: '代币符号',
    totalSupply: '总量',
    network: '网络',
    initialPrice: '初始价格',
    listingPrice: '上市价格',
    
    // Features
    aiContractTitle: 'AI 智能合约',
    aiContractDesc: '智能合约自动执行，交易安全透明，收益实时结算',
    mysteryBoxTitle: '神秘盲盒系统',
    mysteryBoxDesc: '四种稀有度 NFT，独特外观设计，特殊属性加成',
    nftMarketTitle: 'NFT 交易市场',
    nftMarketDesc: '自由交易 NFT，实时市场行情，安全交易保障',

    // Mining Revenue
    miningRevenueTitle: '挖矿收益',
    basicRevenueTitle: '基础收益',
    stakingMechanismTitle: '质押机制',
    revenueBoostTitle: '收益加成',
    
    // Basic Revenue
    nftLevelPower: 'NFT 等级算力',
    dailyRevenueDistribution: '每日收益分配',
    revenueProportionalToPower: '收益与算力成正比',
    
    // Staking Mechanism
    stakeToMine: '质押即可挖矿',
    cannotUnstake: '不可解除质押',
    noLockupPeriod: '无锁定期限',
    
    // Revenue Boost
    nftAttributeBonus: 'NFT 属性加成',
    stakingDurationBonus: '质押时长加成',
    eventBonus: '活动加成',
    
    stakingMechanismTitle: '质押机制',
    baseRevenueTitle: '基础收益',
    baseRevenuePoint1: 'NFT等级越高，基础收益越高',
    baseRevenuePoint2: '每日准时发放收益',
    baseRevenuePoint3: '收益与质押时长成正比',
    
    revenueBoostTitle: '收益加成',
    revenueBoostPoint1: '持有多个NFT可获得加成',
    revenueBoostPoint2: '社区活跃度影响收益',
    revenueBoostPoint3: '特殊活动期间额外奖励',

    // Development Roadmap
    developmentRoadmap: '发展路线',
    phaseOne: '第一阶段',
    phaseTwo: '第二阶段',
    phaseThree: '第三阶段',
    phaseFour: '第四阶段',
    
    phaseOneItem1: '完成智能合约开发',
    phaseOneItem2: '完成 NFT 系统设计',
    phaseOneItem3: '完成官网开发',
    phaseOneItem4: '启动私募',
    
    phaseTwoItem1: 'IDO 启动',
    phaseTwoItem2: 'NFT 挖矿系统上线',
    phaseTwoItem3: '交易市场开放',
    phaseTwoItem4: '开启联合坐庄',
    
    phaseThreeItem1: '上线主流交易所',
    phaseThreeItem2: 'NFT 升级系统上线',
    phaseThreeItem3: '团队挖矿系统上线',
    phaseThreeItem4: '启动社区治理',
    
    phaseFourItem1: 'AI 智能交易系统',
    phaseFourItem2: 'AI 市场分析预测',
    phaseFourItem3: 'AI 个性化投资建议',
    phaseFourItem4: 'AI 风险管理系统',
    
    // Roadmap
    roadmapTitle: '发展路线',
    phase1Title: '第一阶段',
    phase1Point1: '完成智能合约开发',
    phase1Point2: '完成 NFT 系统设计',
    phase1Point3: '完成官网开发',
    phase1Point4: '启动私募',

    phase2Title: '第二阶段',
    phase2Point1: 'IDO 启动',
    phase2Point2: 'NFT 挖矿系统上线',
    phase2Point3: '交易市场开放',
    phase2Point4: '开启联合坐庄',

    phase3Title: '第三阶段',
    phase3Point1: '上线主流交易所',
    phase3Point2: 'NFT 升级系统上线',
    phase3Point3: '团队挖矿系统上线',
    phase3Point4: '启动社区治理',

    phase4Title: '第四阶段',
    phase4Point1: 'AI 智能交易系统',
    phase4Point2: 'AI 市场分析预测',
    phase4Point3: 'AI 个性化投资建议',
    phase4Point4: 'AI 风险管理系统',

    // AI System
    aiSystemTitle: 'AI智能系统',
    flashArbitrageTitle: '闪电套利',
    flashArbitragePoint1: '跨链套利机器人',
    flashArbitragePoint2: '实时价差监控',
    flashArbitragePoint3: '自动交易执行',
    flashArbitragePoint4: '风险控制系统',
    flashArbitrageRequirement: '需要持有SR或以上级别NFT',
    flashArbitrageItem1: '跨链套利机器人',
    flashArbitrageItem2: '实时价差监控',
    flashArbitrageItem3: '自动交易执行',
    flashArbitrageItem4: '风险控制系统',
    srRequirement: '需要持有 SR 或以上级别 NFT',
    
    smartTradingTitle: '智能交易',
    smartTradingPoint1: 'AI 趋势分析',
    smartTradingPoint2: '智能止盈止损',
    smartTradingPoint3: '多策略组合',
    smartTradingPoint4: '实时市场洞察',
    smartTradingRequirement: '需要持有 R 或以上级别 NFT',
    smartTradingItem1: 'AI 趋势分析',
    smartTradingItem2: '智能止盈止损',
    smartTradingItem3: '多策略组合',
    smartTradingItem4: '实时市场洞察',
    rRequirement: '需要持有 R 或以上级别 NFT',
    
    memeRadarTitle: 'MEME 雷达',
    memeRadarPoint1: '社交媒体监控',
    memeRadarPoint2: '热点币种预警',
    memeRadarPoint3: '情绪指标分析',
    memeRadarPoint4: '早期项目发现',
    memeRadarRequirement: '需要持有 SSR 级别 NFT',
    memeRadarItem1: '社交媒体监控',
    memeRadarItem2: '热点币种预警',
    memeRadarItem3: '情绪分析',
    memeRadarItem4: '早期项目发现',
    ssrRequirement: '需要持有 SSR 级别 NFT',
    
    scheduledTradingTitle: '定时交易',
    scheduledTradingItem1: '自定义交易计划',
    scheduledTradingItem2: '条件触发执行',
    scheduledTradingItem3: '多币种监控',
    scheduledTradingItem4: '邮件/Telegram 通知',
    rRequirement: '需要持有 R 或以上级别 NFT',
    
    riskWarningTitle: '风险预警',
    riskWarningItem1: '市场风险监控',
    riskWarningItem2: '异常波动预警',
    riskWarningItem3: '资金流向分析',
    riskWarningItem4: '智能风险管理策略',
    srRequirement: '需要持有 SR 或以上级别 NFT',
    
    dataAnalysisTitle: '数据分析',
    dataAnalysisItem1: '深度市场分析',
    dataAnalysisItem2: '链上数据追踪',
    dataAnalysisItem3: '交易模式识别',
    dataAnalysisItem4: '投资报告生成',
    srRequirement: '需要持有 SR 或以上级别 NFT',
    
    aiSmartSystemTitle: 'AI智能系统',
    
    // Core Features Descriptions
    aiContractDescription: '采用 AI 优化的智能合约系统',
    mysteryBoxDescription: '神秘盲盒中的精彩奖励',
    nftMarketDescription: '独特数字资产的交易与收藏',
    
    // NFT Level System
    nftLevelSystemTitle: 'NFT 等级系统',
    normalNFT: '普通 NFT',
    rareNFT: '稀有 NFT',
    superRareNFT: '超稀有 NFT',
    legendaryNFT: '传说 NFT',
    
    drawProbability: '抽取概率',
    pityValue: '保底值',
    noSpecialGuarantee: '无特殊保障',
    srGuarantee: 'SR 等级保障',
    ssrGuarantee: 'SSR 等级保障',
    
    N: 'N',
    R: 'R',
    SR: 'SR',
    SSR: 'SSR',
    
    // Community
    joinCommunityTitle: '加入社区',
    joinCommunity: '加入社区',
    joinTelegramGroup: '加入电报群组',
    followLatestUpdates: '关注最新动态',
    joinCommunityDiscussion: '加入社区讨论',
    telegramTitle: 'Telegram',
    telegramDescription: '加入我们的电报群',
    twitterDescription: '关注最新动态',
    discordDescription: '加入社区讨论',
    
    communityListTitle: '社区列表',
    binanceCommunityTitle: '币安社区',
    binanceCommunityDescription: '全球最大交易所',
    okxCommunityTitle: 'OKX社区',
    okxCommunityDescription: '领先数字资产平台',
    huobiCommunityTitle: '火币社区',
    huobiCommunityDescription: '专业数字货币交易',
    gateCommunityTitle: 'Gate社区',
    gateCommunityDescription: '创新数字资产平台',
    kucoinCommunityTitle: 'KuCoin社区',
    kucoinCommunityDescription: '全球领先交易所',
    globalLeadingExchange: '全球领先交易所',

    communitiesTitle: '社区列表',
    binanceCommunityTitle: '币安社区',
    binanceCommunityDescription: '全球领先交易所',
    okxCommunityTitle: 'OKX社区',
    okxCommunityDescription: '领先数字资产平台',
    huobiCommunityTitle: '火币社区',
    huobiCommunityDescription: '专业数字货币交易',
    gateCommunityTitle: 'Gate社区',
    gateCommunityDescription: '创新数字资产平台',
    kucoinCommunityTitle: 'KuCoin社区',
    kucoinCommunityDescription: '全球领先交易所',

    // Discord
    discordTitle: 'Discord',
    discordDescription: '加入社区讨论',

    // Twitter
    twitterTitle: 'Twitter',
    twitterDescription: '关注最新动态',

    // Telegram
    telegramTitle: 'Telegram',
    telegramDescription: '加入官方频道',

    // Copyright
    copyright: '2025 ZERO. 版权所有.',
    globalLeadingExchange: '全球领先交易所',
    
    // Project Highlights
    projectHighlights: '项目亮点',
    aiTechnologyAdvancement: 'AI 技术进步',
    securityGuarantee: '安全保障',
    communityGovernance: '社区治理',
    ecosystemExpansion: '生态扩展',
    
    aiTechnologyDesc: '先进的 AI 算法用于智能交易和风险管理',
    securityDesc: '具有实时监控的多层安全系统',
    governanceDesc: '社区驱动的决策和透明治理',
    expansionDesc: '持续的生态系统增长和合作伙伴发展',
    
    // News Announcements
    newsAnnouncements: '新闻公告',
    newsTitle1: 'AI 挖矿系统上线',
    newsContent1: '我们的先进 AI 挖矿系统现已上线，为加密货币挖矿带来智能自动化',
    newsTitle2: '战略合作伙伴关系公告',
    newsContent2: '与领先的区块链安全公司建立新的合作伙伴关系，提升平台安全性',
    newsTitle3: '社区治理更新',
    newsContent3: '引入新的社区投票系统用于项目决策',
    
    // Footer Community List
    communityList: '合作伙伴',
    binanceCommunity: '币安',
    okxCommunity: 'OKX',
    huobiCommunity: '火币',
    kucoinCommunity: 'KuCoin',
    globalLeadingExchange: '全球领先交易所',
  }
};
